import React, {useMemo, useState} from 'react';
import Model from './Model'
import {
    Target,
    Lightbulb,
    FileText,
    Palette,
    Globe,
    Share2,
    Code,
    TrendingUp,
    Megaphone,
    Video,
    Calendar,
    BarChart3,
    Bot,
    Users,
    Heart,
    ShoppingCart,
    Package,
    ChevronDown,
    ChevronUp,
    X
} from 'lucide-react';

// Icon mapping for each service category
const iconMapping = {
    1: Target,
    2: Lightbulb,
    3: FileText,
    4: Palette,
    5: Globe,
    6: Share2,
    7: Code,
    8: TrendingUp,
    9: Megaphone,
    10: Video,
    11: Calendar,
    12: BarChart3,
    13: Bot,
    14: Users,
    15: Heart,
    16: ShoppingCart,
    17: Package
};

// Color mapping for each service category
const colorMapping = {
    1: "purple",
    2: "yellow",
    3: "blue",
    4: "pink",
    5: "green",
    6: "indigo",
    7: "gray",
    8: "emerald",
    9: "red",
    10: "violet",
    11: "amber",
    12: "cyan",
    13: "slate",
    14: "teal",
    15: "rose",
    16: "orange",
    17: "lime"
};
export default class ServiceOffering extends Model
{
	static Key = 'ServiceOffering';

    static normalize(props)
    {
        if (props.service_tags?.length) {
            props.service_tags = TB.map(props.service_tags, tag => {
                if (tag?.category) {
                    tag.category_id = tag.category.id;
                }
                return tag;
            })
        }

        if (!props.image_path) {
            props.image_path = '/images/service_offering.png';
        }

        return props;
    }

    static labelForFeeType(typeId) {
        console.log('labelForFeeType', {typeId})
        let type = laravel.service_fee_types?.[parseInt(typeId)];

        switch (type) {
            case 'Fixed Rate':
                return 'Starting Rate'
            case 'Ongoing Hourly':
            case 'Ongoing Weekly':
            case 'Ongoing Monthly':
                return 'Starting Price'
            case 'Must Contact':
                return false
        }
    }

    static colorForServiceCategory(serviceId) {
        return colorMapping[serviceId];
    }


    static iconForServiceCategory(serviceId) {
        return iconMapping[serviceId];
    }
}